import { useEffect } from 'react'

import { gtmDataLayerPushProductOffersDrawerView } from '../../../../../gtm'
import { useProductPageContext } from '../../../productPageContext'

export const useGtmDataLayerPushProductOffersDrawerView = ({
  isOpen,
}: {
  isOpen: boolean
}): void => {
  const { currentOffer, currentVariant } = useProductPageContext()

  useEffect(() => {
    if (isOpen) {
      gtmDataLayerPushProductOffersDrawerView({
        offerId: currentOffer?.offerId ?? '',
        productName: currentVariant.name,
        pzn: currentVariant.pzn ?? '',
      })
    }
  }, [isOpen, currentOffer, currentVariant])
}
